module.exports = __webpack_public_path__ + "img/regProp-1.3275d2a3.jpg";